import { render, staticRenderFns } from "./ReportSkeleton.vue?vue&type=template&id=5972fea2"
import script from "./ReportSkeleton.vue?vue&type=script&lang=js"
export * from "./ReportSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports